
import './Image.css'
export default function Image({src, alt, onClick, description, className}) {
    return (
        <div className={'image'}>
            <img onClick={() => onClick(src)} src={src} alt={alt} className={className ?? ''}/>
        </div>
    );
}
